<div class="popup-title bg-active d-flex gap-2">
  <img
    [src]="booking?.inquirySource | inquirySourceIcon"
    alt=""
    style="height: 20px"
    [matTooltip]="booking?.sourceView"
    matTooltipPosition="below"
  />
  <div>
    <div class="text-xl text-semi-bold">{{ booking?.guestNameView }}</div>
    <div class="d-flex gap-2 align-items-center">
      <app-booking-paid-status
        [inquiry]="booking"
        [remaining]="false"
        [tooltipDisabled]="true"
        class="text-xs"
        #paidStatus
      ></app-booking-paid-status>
      <div>
        <i class="cs-icon cs-icon-moon text-md text-info"></i>
        {{ booking?.guestDepart | dateDiff : booking?.guestArrive : 'nights' }}
        <i class="far fa-spin fa-spinner" *ngIf="isBookingLoading"></i>
      </div>
      <div>
        <i class="cs-icon cs-icon-adult text-md text-warning"></i>
        {{ (booking?.numAdults || 0) + (booking?.numChild || 0) }}
        <i class="far fa-spin fa-spinner" *ngIf="isBookingLoading"></i>
      </div>
    </div>
  </div>
</div>

<div class="info-list mt-3">
  <div class="info-list-item">
    <div class="icon text-indigo">
      <i class="cs-icon cs-icon-calendar-plus text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>From</div>
      <div class="value">
        {{ booking?.guestArrive | epochUTC : 'DD - MMM - YYYY' }}
        <i class="far fa-spin fa-spinner" *ngIf="isBookingLoading"></i>
      </div>
    </div>
  </div>
  <div class="info-list-item">
    <div class="icon text-indigo">
      <i class="cs-icon cs-icon-calendar-plus text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>To</div>
      <div class="value">
        {{ booking?.guestDepart | epochUTC : 'DD - MMM - YYYY' }}
        <i class="far fa-spin fa-spinner" *ngIf="isBookingLoading"></i>
      </div>
    </div>
  </div>
  <ng-container *ngIf="canSeeCharges$ | async">
    <div class="info-list-item">
      <div class="icon text-warning">
        <i class="cs-icon cs-icon-circle-stack text-xl"></i>
      </div>
      <div>
        <div class="label" i18n>Balance due</div>
        <div class="value">
          {{ paymentStatus?.remaining | tokeetCurrency : rental?.currency }}
          <i class="far fa-spin fa-spinner" *ngIf="isChargeLoading"></i>
        </div>
      </div>
    </div>
    <div class="info-list-item gap-3">
      <div>
        <div class="label" i18n>Paid</div>
        <div class="value">
          {{ charges?.sum - paymentStatus?.remaining | tokeetCurrency : rental?.currency }}
          <i class="far fa-spin fa-spinner" *ngIf="isChargeLoading"></i>
        </div>
      </div>
      <div>
        <div class="label" i18n>Total</div>
        <div class="value">
          {{ charges?.sum | tokeetCurrency : rental?.currency }}
          <i class="far fa-spin fa-spinner" *ngIf="isChargeLoading"></i>
        </div>
      </div>
    </div>
    <div class="info-list-item" *ngIf="!!formulaAdjustedCost">
      <div class="icon text-warning">
        <i class="cs-icon cs-icon-calculator text-xl"></i>
      </div>
      <div>
        <div class="label">
          <span [matTooltip]="getBookingFormulaTooltip()" matTooltipPosition="above" i18n>Booking Formula</span>
        </div>
        <div class="value">
          {{ formulaAdjustedCost | tokeetCurrency : rental?.currency }}
          <i class="far fa-spin fa-spinner" *ngIf="isChargeLoading"></i>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="info-list-item">
    <div class="icon text-success">
      <i class="cs-icon cs-icon-calendar text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>Created On</div>
      <div class="value">
        {{ booking?.created | epoch : 'datetime' }}
        <i class="far fa-spin fa-spinner" *ngIf="isBookingLoading"></i>
      </div>
    </div>
  </div>
</div>
